<template>
    <div class="chart-inner">
      <h1>近期告警事件</h1>
      <vue-seamless-scroll :data="bug" class="warp" :class-option="classOption">
        <ul>
          <li v-for="item in bug">
            <div class="date">{{item.date}}</div>
<!--            <div class="theatre" v-if="item.type == '1'">北京大学</div>-->
<!--            <div class="test" v-if="item.type == '0'">清华大学</div>-->
            <div class="test">
              <el-tooltip class="item" effect="dark" :content="item.ent" placement="top-start">
                <span>{{item.ent}}</span>
              </el-tooltip>
            </div>
            <div class="notice">
                <span>{{item.content}}</span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll >
    </div>
</template>
<script>
import {getAlarmEvents} from "@/service/dashboard";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      bug:[
        {date:"2024-5-19",  type:"0", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-17",  type:"0",  ent:"中国石油大学(华东)", content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-16",  type:"1",  ent:"中国石油大学(华东)", content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",  type:"0", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-13",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-11",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-8",  type:"0",  ent:"中国石油大学(华东)", content:"TP-Link TDDP缓冲区溢出漏洞" },
        {date:"2024-5-17",  type:"0", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-16",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",  type:"0",  ent:"中国石油大学(华东)", content:"Apache dubbo反序列化漏洞"},
        {date:"2024-5-16",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",  type:"0", ent:"中国石油大学(华东)",  content:"Apache dubbo反序列化漏洞"},
        {date:"2024-5-13",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-17",  type:"0",  ent:"中国石油大学(华东)", content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-16",  type:"1", ent:"中国石油大学(华东)",  content:"Apache dubbo反序列化漏洞" },
        {date:"2024-5-15",  type:"0", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-15",  type:"0", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-13",  type:"1", ent:"中国石油大学(华东)",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"}
      ],
      classOption: {
        step: 1,
        singleHeight:0.25 ,
        waitTime: 3000,
        isSingleRemUnit: true

      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getAlarmEvents().then(res => {
        // 遍历原始数据数组
        res.forEach(item => {
          // 提取月和日部分，并格式化为 "MM-DD"
          let formattedDate = item.date.substring(0, 10);

          let newArray = res.map( item => ({
            date:formattedDate,
            ent: item.ent,
            content:item.content
          }));

          this.bug = newArray;
        });
      });
    }
  }
};


</script>
<style lang="less" scoped>
*{
  margin: 0;
  padding: 0;
}
.chart-inner {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    padding-top: 10px;
    padding-left: 35px;
    box-sizing: border-box;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 30px;
  text-align: left;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}

.warp{
  font-family: AlibabaRegular;
  position: absolute;
  left: 28px;
  top: 50px;
  overflow: hidden;
  height: 718px;
}
ul li{
  list-style-type: none; /* 去除项目符号 */
  width: 381px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 7px;
  box-sizing: border-box;
  color: #fff;
}

li:nth-of-type(odd){
  background: url("../../assets/PlatformOverview/textBackground.png") no-repeat;
  background-size: 100%;
}
li .date{
  width: 85px;
}
li .test{
  width: 81px;
  color: rgba(159, 158, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 定义文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    font-family: AlibabaRegular;
  }
}
li .theatre{
  width: 81px;
  color: rgba(244, 191, 54, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    line-height: 14px;
    font-family: AlibabaRegular;
  }
}
li .notice{
  width: 185px;
  height: 48px;
  color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: left;
  align-items: center;
  span{
    text-align: left;
    line-height: 14px;
    font-family: AlibabaRegular;
  }
}

</style>
